var _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g5, _path8, _g6, _path9, _path10, _g7, _path11, _path12, _path13, _path14, _g8, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _line, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _rect, _path43, _rect2, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDasthkathSignHereVector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 557.711,
    height: 485.964,
    viewBox: "0 0 557.711 485.964",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110",
    transform: "translate(-260.08 -270)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    transform: "translate(-23 -439)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87",
    transform: "translate(283.08 709)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Consent-rafiki_2_",
    "data-name": "Consent-rafiki (2)",
    transform: "translate(0 0)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M402.9,256.181C298.968,227.3,260.98,2.808,108.44,124.384.195,210.624,67.971,422.8,204.155,398.831c82.47-14.479,69.726-16.084,139.9,24.585,71.117,41.228,149.286,62.143,224.632-9.82,38.992-37.271,53.872-128.443,15.525-175.878C536.287,178.413,466.389,273.814,402.9,256.181Z",
    transform: "translate(-54.839 -88.559)",
    fill: "#14465e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M402.9,256.181C298.968,227.3,260.98,2.808,108.44,124.384.195,210.624,67.971,422.8,204.155,398.831c82.47-14.479,69.726-16.084,139.9,24.585,71.117,41.228,149.286,62.143,224.632-9.82,38.992-37.271,53.872-128.443,15.525-175.878C536.287,178.413,466.389,273.814,402.9,256.181Z",
    transform: "translate(-54.839 -88.559)",
    fill: "#fff",
    opacity: 0.9
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-3",
    transform: "translate(1.822 453.509)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-3",
    cx: 277.944,
    cy: 16.227,
    rx: 277.944,
    ry: 16.227,
    fill: "#f5f5f5"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clipboard--inject-3",
    transform: "translate(55.856 74.242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M139.384,533.364H384.616a6.637,6.637,0,0,0,6.723-7.469L354.068,155.819a8.458,8.458,0,0,0-8.228-7.469H100.579a6.637,6.637,0,0,0-6.723,7.469L131.127,525.9a8.458,8.458,0,0,0,8.257,7.469Z",
    transform: "translate(-93.803 -136.881)",
    fill: "#14465e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M141.18,533.364H386.412a6.637,6.637,0,0,0,6.723-7.469L355.863,155.819a8.458,8.458,0,0,0-8.228-7.469H102.375a6.637,6.637,0,0,0-6.709,7.469L132.937,525.9a8.458,8.458,0,0,0,8.243,7.469Z",
    transform: "translate(-93.019 -136.881)",
    fill: "#14465e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M141.18,533.364H386.412a6.637,6.637,0,0,0,6.723-7.469L355.863,155.819a8.458,8.458,0,0,0-8.228-7.469H102.375a6.637,6.637,0,0,0-6.709,7.469L132.937,525.9a8.458,8.458,0,0,0,8.243,7.469Z",
    transform: "translate(-93.019 -136.881)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M162.514,176.78h80.277a5.318,5.318,0,0,0,5.39-5.992l-2.251-22.263a1.2,1.2,0,0,0-1.175-1.075H154.587a.96.96,0,0,0-.975,1.075l2.251,22.263A6.78,6.78,0,0,0,162.514,176.78Z",
    transform: "translate(-67.878 -137.271)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M181.3,146.357l.946,9.332h12.013l-.946-9.332a6.8,6.8,0,0,0-6.609-6.006,5.347,5.347,0,0,0-5.4,6.006Zm3.641.516a2.15,2.15,0,0,1,2.179-2.437,2.752,2.752,0,0,1,2.666,2.437,2.15,2.15,0,0,1-2.179,2.423,2.738,2.738,0,0,1-2.666-2.423Z",
    transform: "translate(-55.889 -140.349)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M162.514,176.78h80.277a5.318,5.318,0,0,0,5.39-5.992l-2.251-22.263a1.2,1.2,0,0,0-1.175-1.075H154.587a.96.96,0,0,0-.975,1.075l2.251,22.263A6.78,6.78,0,0,0,162.514,176.78Z",
    transform: "translate(-67.878 -137.271)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M347.009,156.76H103.67l35.236,362.035H382.245Z",
    transform: "translate(-89.526 -133.235)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M141.23,179.52h2.021l1.061,10.837h-1.978Z",
    transform: "translate(-73.243 -123.368)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M153.231,184.879l.459,4.731h-1.935l-.444-4.487a2.1,2.1,0,0,0-2.179-2.179,2.025,2.025,0,0,0-2.064,2.494l.4,4.172h-1.935l-.8-8.257h1.821l.1,1.061a3.268,3.268,0,0,1,2.738-1.161,3.627,3.627,0,0,1,3.842,3.627Z",
    transform: "translate(-71.726 -122.621)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M154.606,181.883v.5h2.279l.143,1.548h-2.222l.659,6.652h-1.95l-.645-6.652h-1.434l-.158-1.548h1.434v-.53a2.394,2.394,0,0,1,2.681-2.867,3.311,3.311,0,0,1,1.806.444l-.4,1.434a2.079,2.079,0,0,0-1.1-.33C154.892,180.578,154.52,181.023,154.606,181.883Z",
    transform: "translate(-68.886 -123.61)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M155.861,185.483a3.713,3.713,0,0,1,3.985-4.229,4.659,4.659,0,0,1,4.831,4.229,3.727,3.727,0,0,1-4,4.3A4.688,4.688,0,0,1,155.861,185.483Zm6.867,0a2.709,2.709,0,0,0-2.709-2.58,2.15,2.15,0,0,0-2.208,2.58,2.709,2.709,0,0,0,2.709,2.58,2.15,2.15,0,0,0,2.208-2.58Z",
    transform: "translate(-66.917 -122.622)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M167.808,181.257l.172,1.849a2.867,2.867,0,0,0-.459,0c-1.434,0-2.308.874-2.15,2.566l.387,4h-1.935l-.8-8.257h1.849l.115,1.2A2.867,2.867,0,0,1,167.808,181.257Z",
    transform: "translate(-63.797 -122.626)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M181.7,184.879l.459,4.731h-1.935l-.444-4.487c-.143-1.434-.889-2.179-2.064-2.179s-2.079.831-1.921,2.48l.416,4.186h-1.95l-.43-4.487c-.143-1.434-.9-2.179-2.079-2.179s-2.064.831-1.907,2.48l.4,4.186h-1.935l-.8-8.257h1.849l.1,1.046a3.082,3.082,0,0,1,2.595-1.147,3.455,3.455,0,0,1,2.867,1.434,3.5,3.5,0,0,1,2.967-1.434,3.57,3.57,0,0,1,3.813,3.627Z",
    transform: "translate(-61.85 -122.621)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M187.264,186.115H180.77a2.867,2.867,0,0,0,2.867,1.978,2.667,2.667,0,0,0,2.15-.889l1.161,1.19a3.784,3.784,0,0,1-3.2,1.348,4.7,4.7,0,0,1-4.989-4.3,3.67,3.67,0,0,1,3.87-4.229,4.544,4.544,0,0,1,4.6,4.3A4.239,4.239,0,0,1,187.264,186.115Zm-6.637-1.276h4.7a2.537,2.537,0,0,0-2.537-2.021,2.036,2.036,0,0,0-2.165,2.021Z",
    transform: "translate(-56.991 -122.638)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M193.582,179.109l1.118,11.468h-1.864l-.1-1.061a3.111,3.111,0,0,1-2.638,1.175,4.544,4.544,0,0,1-4.6-4.3,3.6,3.6,0,0,1,3.785-4.229,3.713,3.713,0,0,1,2.767,1.118l-.4-4.3Zm-1.19,7.354a2.709,2.709,0,0,0-2.724-2.58,2.15,2.15,0,0,0-2.208,2.58,2.709,2.709,0,0,0,2.709,2.58,2.165,2.165,0,0,0,2.222-2.58Z",
    transform: "translate(-54.077 -123.602)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M195.893,184.987a4.931,4.931,0,0,1,5.275-5.562,6.092,6.092,0,0,1,4.473,1.806l-1.19,1.219a4.3,4.3,0,0,0-3.025-1.261,3.311,3.311,0,0,0-3.512,3.8,4.172,4.172,0,0,0,4.3,3.813,3.369,3.369,0,0,0,2.767-1.29l1.434,1.247a5,5,0,0,1-4.143,1.806,6.207,6.207,0,0,1-6.379-5.576Z",
    transform: "translate(-49.564 -123.416)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M203.561,185.483a3.713,3.713,0,0,1,3.985-4.229,4.673,4.673,0,0,1,4.831,4.229,3.727,3.727,0,0,1-4,4.3,4.688,4.688,0,0,1-4.817-4.3Zm6.867,0a2.709,2.709,0,0,0-2.724-2.58,2.15,2.15,0,0,0-2.193,2.58,2.7,2.7,0,0,0,2.7,2.58,2.15,2.15,0,0,0,2.222-2.58Z",
    transform: "translate(-46.238 -122.622)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M219.221,184.879l.459,4.731h-1.935l-.444-4.487a2.1,2.1,0,0,0-2.179-2.179,2.025,2.025,0,0,0-2.064,2.494l.4,4.172h-1.935l-.8-8.257h1.835l.1,1.061a3.268,3.268,0,0,1,2.738-1.161,3.627,3.627,0,0,1,3.827,3.627Z",
    transform: "translate(-43.118 -122.621)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M218.073,188.782l.6-1.434a6.107,6.107,0,0,0,2.967.817c1.233,0,1.706-.344,1.649-.917-.158-1.577-5.132-.086-5.447-3.383-.158-1.577,1.161-2.595,3.4-2.595a7.167,7.167,0,0,1,3.168.717l-.6,1.434a4.916,4.916,0,0,0-2.437-.616c-1.175,0-1.692.387-1.649.932.172,1.677,5.146.186,5.462,3.426.143,1.548-1.19,2.552-3.512,2.552a7.082,7.082,0,0,1-3.6-.932Z",
    transform: "translate(-40.035 -122.61)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M232.013,186.115H225.52a2.867,2.867,0,0,0,2.867,1.978,2.7,2.7,0,0,0,2.165-.889l1.161,1.19a3.8,3.8,0,0,1-3.211,1.348,4.731,4.731,0,0,1-4.989-4.3,3.684,3.684,0,0,1,3.87-4.229,4.53,4.53,0,0,1,4.6,4.3C232,185.7,232.013,185.928,232.013,186.115Zm-6.637-1.276h4.7a2.537,2.537,0,0,0-2.537-2.021,2.036,2.036,0,0,0-2.165,2.021Z",
    transform: "translate(-37.59 -122.638)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M238.926,184.858l.459,4.731H237.45l-.473-4.415a2.1,2.1,0,0,0-2.179-2.179,2.025,2.025,0,0,0-2.064,2.494l.4,4.172h-1.892l-.8-8.257h1.835l.115,1.061a3.24,3.24,0,0,1,2.738-1.161,3.627,3.627,0,0,1,3.8,3.555Z",
    transform: "translate(-34.569 -122.599)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M243.908,189.688a3.154,3.154,0,0,1-4.931-2.236l-.387-3.971h-1.362l-.158-1.548H238.5l-.186-1.892h1.95l.186,1.892h2.208l.158,1.548H240.6l.387,3.928a1.2,1.2,0,0,0,1.261,1.247,1.648,1.648,0,0,0,1.061-.344Z",
    transform: "translate(-31.695 -123.143)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_29",
    "data-name": "Line 29",
    x2: 234.28,
    transform: "translate(25.168 90.255)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M324.821,224.529H125.691L124.63,213.72H323.774Z",
    transform: "translate(-80.44 -108.542)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(63.958 128.766)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M320.291,234.354H140.685a2.093,2.093,0,1,1,0-4.172H320.291a2.093,2.093,0,1,1,0,4.172Z",
    transform: "translate(-138.419 -230.175)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(45.61 139.181)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M326.857,241.626H127.713a2.093,2.093,0,1,1,0-4.186H326.857a2.093,2.093,0,1,1,0,4.186Z",
    transform: "translate(-125.62 -237.44)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(46.627 149.588)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M327.553,248.886H128.423a2.093,2.093,0,0,1,0-4.186h199.13a2.093,2.093,0,1,1,0,4.186Z",
    transform: "translate(-126.33 -244.7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(47.645 159.996)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M328.263,256.146H129.133a2.093,2.093,0,0,1,0-4.186h199.13a2.093,2.093,0,0,1,0,4.186Z",
    transform: "translate(-127.04 -251.96)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    transform: "translate(48.822 170.417)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M328.925,263.4H129.781a2.093,2.093,0,0,1,0-4.171H328.925a2.093,2.093,0,0,1,0,4.172Z",
    transform: "translate(-127.861 -259.23)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(49.494 180.817)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M329.725,270.664H130.6a2.093,2.093,0,1,1,0-4.172h199.13a2.093,2.093,0,1,1,0,4.172Z",
    transform: "translate(-128.329 -266.485)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    transform: "translate(50.511 191.225)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M310.939,277.924H131.305a2.093,2.093,0,1,1,0-4.172H310.939a2.093,2.093,0,1,1,0,4.172Z",
    transform: "translate(-129.039 -273.745)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M332.366,302.149H133.236L132.19,291.34H331.32Z",
    transform: "translate(-77.162 -74.893)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(74.752 240.05)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M327.849,311.984H148.215a2.093,2.093,0,1,1,0-4.172H327.849a2.093,2.093,0,1,1,0,4.172Z",
    transform: "translate(-145.949 -307.805)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    transform: "translate(56.274 250.486)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M334.455,319.264H135.325a2.093,2.093,0,1,1,0-4.172h199.13a2.093,2.093,0,1,1,0,4.172Z",
    transform: "translate(-133.059 -315.085)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54",
    transform: "translate(57.624 260.872)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M335.065,326.5H135.921a2.093,2.093,0,0,1,0-4.172H335.065a2.093,2.093,0,0,1,0,4.172Z",
    transform: "translate(-134.001 -322.33)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(58.641 271.272)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M335.818,333.764H136.631a2.093,2.093,0,0,1,0-4.172H335.818a2.093,2.093,0,1,1,0,4.172Z",
    transform: "translate(-134.711 -329.585)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(59.356 281.68)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M233.521,341.024H137.475a2.093,2.093,0,1,1,0-4.171h96.046a2.093,2.093,0,1,1,0,4.172Z",
    transform: "translate(-135.209 -336.845)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    transform: "translate(125.127 346.037)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 73.482,
    height: 1.391
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M183.235,365.381a6.894,6.894,0,0,0-1.176-1.061,1.562,1.562,0,0,0,.115.215c.473.946.889,1.907,1.262,2.867a2.767,2.767,0,0,0,.229-1.348,1.749,1.749,0,0,0-.43-.674Z",
    transform: "translate(-55.543 -43.255)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M189.1,380.986a.8.8,0,0,0,0-.115l-.244-.258a.187.187,0,0,0-.086-.158.2.2,0,0,1,0-.086q0-.258,0-.516c.215-1.677.258-3.4.373-5.1l5.247-2.179a26.8,26.8,0,0,0-1.935-5.218,27.738,27.738,0,0,0-3.025-4.774l-24.37,10.135h0a1.821,1.821,0,0,1-.5,1.261c-.373.272-1.1,0-1.132-.4l-.444.416a2.093,2.093,0,0,1-.516.487l.516-.487a3.2,3.2,0,0,0,.344-.573l-16.4,6.809a25.706,25.706,0,0,0,1.935,5.232,27.625,27.625,0,0,0,3.025,4.759L157.5,387.9a.574.574,0,0,1-.129-.33c-.143-1.835,4.917-3.254,6.221-3.77a2.021,2.021,0,0,1,2.05,0c-.287.416-.846.53-1.3.774a5.29,5.29,0,0,0-1.118.932l23.366-9.7a12.542,12.542,0,0,0,.315,2.752c.115.559.215,1.2.4,1.806a12.519,12.519,0,0,1-.3,1.434.2.2,0,0,0,0,.1l-9.863,4.085h0a.43.43,0,0,1,.129.545,1.175,1.175,0,0,1-.459.373c-1.018.53-4.458,2.867-5.548,2.021a11.675,11.675,0,0,1,.96-.917l-16.027,6.723c7.282,5.92,17.2,7.97,25.7,4.43a17.5,17.5,0,0,0,1.735-.817,1.5,1.5,0,0,1,.072-.559v-.96a3.527,3.527,0,0,1,1.434-.774c-.115.53-.186,1.075-.287,1.62a21.746,21.746,0,0,0,10.307-19.109Z",
    transform: "translate(-70.772 -44.009)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M146.908,396.352c0-.4-.1-.86-.158-1.434a4.629,4.629,0,0,1,.072-1.261c-.115-.2-.229-.373-.33-.573a31.149,31.149,0,0,1-3.3-15.453l-.2.1a.473.473,0,0,1-.545,0,.6.6,0,0,1-.129-.272,7.325,7.325,0,0,1,.143-3.612l.158-.459a1.434,1.434,0,0,1,.616-.43.66.66,0,0,1,.545.072,26.993,26.993,0,0,1,4.573-10.264c.473-2.007,1.261-3.928,2.652-4.143a4.142,4.142,0,0,0-.2,1.319,26.033,26.033,0,0,1,8.6-5.82c13.217-5.49,29.186,0,37.873,12.185a1.433,1.433,0,0,1,.43,0c1.649.158,3.354,3.9,4.114,5.118.6.989,1.233,2.251.659,3.154a.688.688,0,0,1-.631.373.745.745,0,0,1-.186-.086,28.814,28.814,0,0,1-2.322,24.5,8.5,8.5,0,0,1,.186,3.956c6.924-8.845,8.343-21.646,2.537-33.3-8.214-16.528-27.825-24.6-43.722-17.991s-22.148,25.4-13.934,41.93a36.756,36.756,0,0,0,2.451,4.186,5.848,5.848,0,0,0,0-1.319Z",
    transform: "translate(-73.431 -49.584)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M164.347,396.886c0,.416-.459.745-.917.817a3.512,3.512,0,0,1-2.867-.989l-.788-.731a16.42,16.42,0,0,1,2.222,0,34.4,34.4,0,0,1-16.758-15.253,8.945,8.945,0,0,0-.143,2.236v.473a15.771,15.771,0,0,0,.287,1.806c9.3,13.3,26.62,19.252,40.941,13.317a28.04,28.04,0,0,0,10.465-7.526V389.89a26.805,26.805,0,0,1,.115-2.982,26.018,26.018,0,0,1-11.654,9.533,29.774,29.774,0,0,1-20.9.444Z",
    transform: "translate(-71.575 -36.141)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M151.383,375.281l.831-1.433a1.433,1.433,0,0,1,1.434-.43,6.52,6.52,0,0,0,1.577.143,2.1,2.1,0,0,1,.788-.086v.072l13.762-5.734a.359.359,0,0,1,0,.129v.115h0a2.535,2.535,0,0,1,.115.573.788.788,0,0,0,1.018.573,4.186,4.186,0,0,0,1.849-1.907l.3-.53a2.7,2.7,0,0,0,.3-.516l11.927-4.96a28.528,28.528,0,0,0-5.433-3.455,1.276,1.276,0,0,0-.172-.559,1.433,1.433,0,0,0-.33-.4c-.086.559-.172,1.1-.3,1.663l-.717.143a1.434,1.434,0,0,1-.473-1.348,2.022,2.022,0,0,1,.229-.7,1.262,1.262,0,0,0-.416.258,24.284,24.284,0,0,0-18.091,0,21.646,21.646,0,0,0-13.26,20.6l5.978-2.48A.918.918,0,0,0,151.383,375.281Z",
    transform: "translate(-71.039 -47.234)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M207.946,392.1a12.465,12.465,0,0,1,.186-1.247,16.269,16.269,0,0,1,0-1.677,2.38,2.38,0,0,1,1.147-1.677,36.511,36.511,0,0,0-3.885-17.675,40.21,40.21,0,0,0-22.506-19.911,5.553,5.553,0,0,0-.315.659c-.244.731-1.434.4-1.362-.373a2.5,2.5,0,0,0-.143-.874,34.619,34.619,0,0,0-23.18.96,31.376,31.376,0,0,0-4.157,2.107c0,.588.1,1.161.158,1.749a2.738,2.738,0,0,1-1.433-.932c-13.145,8.845-17.589,26.706-9.676,42.618a39.958,39.958,0,0,0,4.086,6.522,5.333,5.333,0,0,1,.43-1.964,7.068,7.068,0,0,0,.416-1.433,36.748,36.748,0,0,1-2.451-4.186c-8.214-16.528-1.964-35.336,13.934-41.93s35.508,1.433,43.722,17.991c5.806,11.654,4.387,24.456-2.537,33.3a6.815,6.815,0,0,0,0,.86c0,.7,0,1.433,0,2.122v1.434a31.193,31.193,0,0,0,8.243-15.353h-.158A1.433,1.433,0,0,1,207.946,392.1Z",
    transform: "translate(-74.276 -50.425)",
    fill: "#14465e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M186.231,397.157c-14.335,5.935-31.638,0-40.941-13.317.158.788.344,1.591.53,2.365a3.856,3.856,0,0,1-.244,2.322,40.138,40.138,0,0,0,17.432,11.726,2.351,2.351,0,0,1,1.061-.7,4.3,4.3,0,0,1,1.663,0,.8.8,0,0,1,.444.129,1.032,1.032,0,0,1,.315.416c.215.459.444.9.674,1.434a34.118,34.118,0,0,0,20.342-1.677,30.648,30.648,0,0,0,9.3-6.007c-.086-1.434-.129-2.738-.115-4.1a28.041,28.041,0,0,1-10.465,7.411Z",
    transform: "translate(-71.483 -34.792)",
    fill: "#14465e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M200.986,374.131a1.061,1.061,0,0,1-.387-1.089h0a29.962,29.962,0,0,0-1.261-2.867,1.565,1.565,0,0,1-.115-.215h-.086a3.253,3.253,0,0,1-1.161-1.032,6.621,6.621,0,0,0-.559-1.3c-.229-.315-.788-.143-1-.459-.473-.688-.416-1.319.172-1.434-8.687-12.214-24.656-17.675-37.873-12.185a26.031,26.031,0,0,0-8.6,5.82,6.42,6.42,0,0,1-.072,1.046,4.3,4.3,0,0,1-1.075,1.763,9.776,9.776,0,0,0-2.021,4.086c.158-.889.344-2.509.717-4.071a26.993,26.993,0,0,0-4.573,10.264.487.487,0,0,1,.172.172,1.047,1.047,0,0,1,0,.631,3.7,3.7,0,0,0,.186,1.62,2.481,2.481,0,0,1,.215.7,1.664,1.664,0,0,1-1.19,1.434,31.15,31.15,0,0,0,3.3,15.453c.1.2.215.373.33.573l.086-.6c.115-.588.229-1.175.33-1.763a3.3,3.3,0,0,1-.129,2.523v.272a34.4,34.4,0,0,0,16.758,15.253,5.243,5.243,0,0,1,1.333.115c.444.115.889.172,1.046.559v.229a29.774,29.774,0,0,0,20.915-.444,26.019,26.019,0,0,0,11.654-9.533,6.037,6.037,0,0,1,.215-1.319.917.917,0,0,1,.387.387,28.814,28.814,0,0,0,2.294-24.585Zm-39.694-15.554a24.283,24.283,0,0,1,18.091,0,1.261,1.261,0,0,1,.416-.258c.086-.2.2-.387.3-.573.258-.444.616-.932,1.147-.86a11.119,11.119,0,0,1-.186,1.677,1.433,1.433,0,0,1,.33.4,1.275,1.275,0,0,1,.172.559A28.521,28.521,0,0,1,187,362.978l-11.927,5.046a2.7,2.7,0,0,1-.3.516l-.3.53a4.186,4.186,0,0,1-1.849,1.907.788.788,0,0,1-1.018-.573,2.535,2.535,0,0,0-.115-.573h0v-.115a.358.358,0,0,0,0-.129l-13.762,5.734c-.645.889-1.433,1.821-2.638,1.692a6.384,6.384,0,0,1-.96-.2l-5.978,2.48A21.646,21.646,0,0,1,161.292,358.578Zm25.488,43.851a8.4,8.4,0,0,1-.2,1.176,5.319,5.319,0,0,1-1.348,3.555,31.815,31.815,0,0,1,.344-4.057,17.466,17.466,0,0,1-1.735.817c-8.515,3.541-18.421,1.434-25.7-4.43l15.984-6.637,1.505-1.29a3.914,3.914,0,0,1,1.075-.717,4.214,4.214,0,0,1,2.079-.086.672.672,0,0,1,.244,0l9.834-4.071a.2.2,0,0,1,0-.1,12.517,12.517,0,0,0,.3-1.434c-.186-.6-.287-1.247-.4-1.806a12.544,12.544,0,0,1-.315-2.752l-23.366,9.7-.229.229c-.688.631-4.759,3.125-5.49,2.15L153.752,395a27.623,27.623,0,0,1-3.025-4.759,25.7,25.7,0,0,1-1.935-5.232l16.4-6.809c.387-.774.659-1.677,1.434-1.95a1.348,1.348,0,0,1,.272,1.233l24.37-10.135a27.737,27.737,0,0,1,3.025,4.774,26.793,26.793,0,0,1,1.935,5.218l-5.247,2.179c-.115,1.706-.158,3.426-.373,5.1v.516a.2.2,0,0,0,0,.086s.129.215.086.158l.244.258a.8.8,0,0,1,0,.115l6.035-2.509a21.746,21.746,0,0,1-10.192,19.181Z",
    transform: "translate(-72.72 -48.851)",
    fill: "#14465e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M198.773,375.869c8.085-4.673,14.335,14.937.516,26.434s-32.971,2.165-22.793-20.657,30.72-23.653,37.73-16.772,5.333,23.667.287,22.822,4.43-16.772,11.468-15.668,5.533,17.2,1.434,15.453,3.885-11.067,9.418-10.78,4.1,11.11,1.046,10.78,2.437-8.859,14.335-8.314",
    transform: "translate(-59.197 -44.654)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M238.4,169.746H205.878a1.29,1.29,0,0,1-1.276-1.089,5.5,5.5,0,0,0-5.29-4.559,4.028,4.028,0,0,0-4.114,4.3,1.247,1.247,0,0,1-.358.932,1.29,1.29,0,0,1-.932.4H161.382a1.3,1.3,0,0,1-1.29-1.161l-1.62-16.141a1.262,1.262,0,0,1,.33-.989,1.276,1.276,0,0,1,.96-.43h77.023a1.276,1.276,0,0,1,1.276,1.161l1.634,16.113a1.276,1.276,0,0,1-1.29,1.434Zm-31.537-2.58h30.1l-1.362-13.532H161.181l1.362,13.532h30.1a6.566,6.566,0,0,1,1.763-3.627,6.68,6.68,0,0,1,4.86-2.021,8.171,8.171,0,0,1,7.626,5.648Z",
    transform: "translate(-65.771 -135.728)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    transform: "translate(92.694 15.282)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M238.4,169.746H205.878a1.29,1.29,0,0,1-1.276-1.089,5.5,5.5,0,0,0-5.29-4.559,4.028,4.028,0,0,0-4.114,4.3,1.247,1.247,0,0,1-.358.932,1.29,1.29,0,0,1-.932.4H161.382a1.3,1.3,0,0,1-1.29-1.161l-1.62-16.141a1.262,1.262,0,0,1,.33-.989,1.276,1.276,0,0,1,.96-.43h77.023a1.276,1.276,0,0,1,1.276,1.161l1.634,16.113a1.276,1.276,0,0,1-1.29,1.434Zm-31.537-2.58h30.1l-1.362-13.532H161.181l1.362,13.532h30.1a6.566,6.566,0,0,1,1.763-3.627,6.68,6.68,0,0,1,4.86-2.021,8.171,8.171,0,0,1,7.626,5.648Z",
    transform: "translate(-158.465 -151.01)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M163.918,152.529a2.107,2.107,0,0,0-1.018-1.749h67.189a2.107,2.107,0,0,1,1.018,1.749c.129,1.434-.674,1.763-.674,1.763H163.244S164.047,153.962,163.918,152.529Z",
    transform: "translate(-63.849 -135.828)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M163.918,152.529a2.107,2.107,0,0,0-1.018-1.749h67.189a2.107,2.107,0,0,1,1.018,1.749c.129,1.434-.674,1.763-.674,1.763H163.244S164.047,153.962,163.918,152.529Z",
    transform: "translate(-63.849 -135.828)",
    fill: "#fff",
    opacity: 0.3
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arrow--inject-3",
    transform: "translate(234.883 368.186)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M253.754,345.4,218.69,371l35.064,25.588v-8.458h88.563V353.858H253.754Z",
    transform: "translate(-218.69 -345.4)",
    fill: "#14465e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M249.3,368.018l.616-1.434a5.3,5.3,0,0,0,3.182,1.061c1.505,0,2.136-.53,2.136-1.247,0-2.079-5.734-.717-5.734-4.3,0-1.548,1.247-2.867,3.885-2.867a5.992,5.992,0,0,1,3.211.86l-.559,1.434a5.318,5.318,0,0,0-2.652-.76c-1.434,0-2.107.573-2.107,1.3,0,2.064,5.734.717,5.734,4.3,0,1.548-1.247,2.867-3.9,2.867a6.207,6.207,0,0,1-3.813-1.218Z",
    transform: "translate(-205.42 -339.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M255.64,359.683a1.032,1.032,0,0,1,1.089-1.032,1.018,1.018,0,0,1,1.1.989,1.061,1.061,0,0,1-1.1,1.075,1.046,1.046,0,0,1-1.089-1.032Zm.229,2.236h1.72v7.368h-1.72Z",
    transform: "translate(-202.672 -339.657)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M266.02,360.97v6.25c0,2.666-1.434,3.885-3.971,3.885a5.877,5.877,0,0,1-3.584-1.046l.774-1.29a4.487,4.487,0,0,0,2.724.874c1.62,0,2.337-.745,2.337-2.236v-.387a3.2,3.2,0,0,1-2.466.989,3.584,3.584,0,0,1,0-7.168,3.211,3.211,0,0,1,2.552,1.061v-.989Zm-1.692,3.469a2.236,2.236,0,1,0-2.236,2.236A2.236,2.236,0,0,0,264.328,364.439Z",
    transform: "translate(-201.54 -338.708)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M272.5,364.108v4.215h-1.735v-4c0-1.3-.645-1.95-1.749-1.95a1.964,1.964,0,0,0-2.05,2.222v3.727h-1.72v-7.368h1.634v.96a3.226,3.226,0,0,1,2.537-1.032,2.867,2.867,0,0,1,3.082,3.225Z",
    transform: "translate(-198.505 -338.692)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M281.729,364.951v4.215h-1.72v-4c0-1.3-.645-1.95-1.749-1.95a1.964,1.964,0,0,0-2.05,2.222v3.727h-1.72V358.93h1.72v3.727a3.283,3.283,0,0,1,2.451-.932,2.867,2.867,0,0,1,3.068,3.225Z",
    transform: "translate(-194.5 -339.535)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M288.185,365.182h-5.734a2.236,2.236,0,0,0,2.38,1.778,2.7,2.7,0,0,0,2.007-.8l.917,1.061a4.143,4.143,0,0,1-7.024-2.58,3.655,3.655,0,0,1,3.8-3.756,3.584,3.584,0,0,1,3.727,3.8A2.117,2.117,0,0,1,288.185,365.182Zm-5.734-1.133h4.172a1.993,1.993,0,0,0-2.079-1.792,2.036,2.036,0,0,0-2.15,1.792Z",
    transform: "translate(-191.795 -338.69)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M291.358,360.884v1.606h-.4a2.007,2.007,0,0,0-2.136,2.279v3.569H287.1V360.97h1.634v1.075a2.939,2.939,0,0,1,2.623-1.161Z",
    transform: "translate(-189.033 -338.693)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M298.1,365.182h-5.734a2.236,2.236,0,0,0,2.38,1.778,2.7,2.7,0,0,0,2.007-.8l.917,1.061a4.143,4.143,0,0,1-7.024-2.58,3.655,3.655,0,0,1,3.8-3.756,3.584,3.584,0,0,1,3.727,3.8A2.818,2.818,0,0,0,298.1,365.182Zm-5.734-1.133h4.172a1.993,1.993,0,0,0-2.079-1.792,2.036,2.036,0,0,0-2.15,1.792Z",
    transform: "translate(-187.495 -338.69)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-3",
    transform: "translate(369.939 116.64)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M400.6,225.779a192.109,192.109,0,0,1-16.313,12.113c-2.867,1.907-5.734,3.727-8.873,5.433-1.548.846-3.154,1.677-4.917,2.451-.889.373-1.792.745-2.867,1.089-.487.172-1.061.344-1.62.487-.172,0-.215.072-.487.129l-.717.143a8.98,8.98,0,0,1-1.362.143,15.239,15.239,0,0,1-7.6-1.921,34.7,34.7,0,0,1-4.989-3.182,69.37,69.37,0,0,1-7.9-7.168,121.037,121.037,0,0,1-12.816-15.9l5.146-4.3c4.7,4.4,9.6,8.773,14.507,12.73a75.083,75.083,0,0,0,7.454,5.333,23.29,23.29,0,0,0,3.555,1.821,3.712,3.712,0,0,0,1.906.43h-.129a6.648,6.648,0,0,0,.731-.3,18.957,18.957,0,0,0,1.735-.846c1.218-.659,2.509-1.434,3.8-2.236,2.58-1.634,5.175-3.455,7.77-5.3s5.161-3.813,7.727-5.734,5.146-3.971,7.641-5.877Z",
    transform: "translate(-305.431 -150.255)",
    fill: "#dc897c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M393.06,219.433c1.161,13.848-26.334,27.237-26.334,27.237l-9.146-14.909A158.424,158.424,0,0,1,374.7,213.7C383.57,206.159,392.285,210.23,393.06,219.433Z",
    transform: "translate(-293.535 -152.653)",
    fill: "#14465e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M383.67,235.543a66.555,66.555,0,0,1-6.823,5.189,94.186,94.186,0,0,1-10.121,5.963l-9.146-14.909a157.68,157.68,0,0,1,17.13-18.062c8.859-7.569,17.589-3.5,18.349,5.734C393.547,225.193,389.06,230.884,383.67,235.543Z",
    transform: "translate(-293.535 -152.65)",
    fill: "#fff",
    opacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M338.386,218.826l-7.641-10.336-7.856,8.028s4.3,7.985,11.741,7.053Z",
    transform: "translate(-308.574 -153.207)",
    fill: "#e4897b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M323.96,205.73l-4.43,7.4,4.817,4.587,7.856-8.028Z",
    transform: "translate(-310.031 -154.403)",
    fill: "#e4897b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M377.844,229.341a66.548,66.548,0,0,1-6.824,5.189,43.937,43.937,0,0,1,4.731-10.45A9.16,9.16,0,0,1,377.844,229.341Z",
    transform: "translate(-287.709 -146.448)",
    opacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M373.592,409.357l10.794-.287a.86.86,0,0,1,.86.645l2.279,8.687a1.434,1.434,0,0,1-1.362,1.792c-3.9,0-9.533,0-14.421.1-5.734.143-9.361-.129-16.07,0-4.057.115-5.333-3.942-3.655-4.3,7.669-1.892,12.687-1.52,19.223-5.734a4.4,4.4,0,0,1,2.351-.9Z",
    transform: "translate(-296.258 -66.252)",
    fill: "#263238"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(55.041 342.817)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M373.592,409.357l10.794-.287a.86.86,0,0,1,.86.645l2.279,8.687a1.434,1.434,0,0,1-1.362,1.792c-3.9,0-9.533,0-14.421.1-5.734.143-9.361-.129-16.07,0-4.057.115-5.333-3.942-3.655-4.3,7.669-1.892,12.687-1.52,19.223-5.734a4.4,4.4,0,0,1,2.351-.9Z",
    transform: "translate(-351.299 -409.07)",
    fill: "#fff"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M411.9,409.357l10.794-.287a.86.86,0,0,1,.86.645l2.265,8.687a1.434,1.434,0,0,1-1.362,1.792c-3.885,0-9.519,0-14.421.1-5.734.143-9.361-.129-16.07,0-4.057.115-5.318-3.942-3.641-4.3,7.669-1.892,12.687-1.52,19.223-5.734a4.3,4.3,0,0,1,2.351-.9Z",
    transform: "translate(-279.651 -66.252)",
    fill: "#263238"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(109.956 342.817)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M411.9,409.357l10.794-.287a.86.86,0,0,1,.86.645l2.265,8.687a1.434,1.434,0,0,1-1.362,1.792c-3.885,0-9.519,0-14.421.1-5.734.143-9.361-.129-16.07,0-4.057.115-5.318-3.942-3.641-4.3,7.669-1.892,12.687-1.52,19.223-5.734a4.3,4.3,0,0,1,2.351-.9Z",
    transform: "translate(-389.607 -409.07)",
    fill: "#fff"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M441.38,260.56c5.2,22.506-5.118,214.54-5.118,214.54l-17.045-.53L413.1,312.582,380.641,476.061l-16.571-2.48C376.1,359.3,390.26,276.243,390.26,276.243v-8.6Z",
    transform: "translate(-290.722 -130.634)",
    fill: "#263238"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M428.111,202.481a214.024,214.024,0,0,0,.817,32.268c.7,7.483,1.706,14.565,2.767,20.958,2.466,14.98,5.29,26.2,5.734,30.1l-51.162,7.067c-18.636-52.18-11.626-79.861-11.626-79.861l11.712-6.695,2.595-.659a193.535,193.535,0,0,1,21.761-3c1.434-.129,2.8-.215,4.157-.272C421.8,202.094,428.111,202.481,428.111,202.481Z",
    transform: "translate(-286.699 -155.899)",
    fill: "#14465e"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    transform: "translate(86.563 46.37)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M437.383,285.829c-7.512,1.046-35.766,4.946-51.177,7.053-18.636-52.166-11.626-79.847-11.626-79.847l11.712-6.68s1.72-.459,2.609-.674a192.781,192.781,0,0,1,21.747-3c1.433-.115,2.8-.215,4.157-.272,7-.315,13.289,0,13.289,0a203.768,203.768,0,0,0,0,20.714c.2,3.942.487,7.8.831,11.554v.53c.717,7.282,1.692,14.192,2.724,20.428C434.186,270.691,437,281.915,437.383,285.829Z",
    transform: "translate(-373.289 -202.272)",
    fill: "#fff"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M404.561,209.487s-11.74,9.261-15.267,9.218c-2.48,0-6.064-4.071-6.064-4.071a10.637,10.637,0,0,0,3.871-3.1c2.451-3.369,1.032-7.44-.975-11.181l10.307-14.335a68.435,68.435,0,0,0,1.319,10.379h0C398.913,202,401.006,207.494,404.561,209.487Z",
    transform: "translate(-282.416 -162.948)",
    fill: "#e4897b"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M396.876,196.432h0c-1.075,6.25-3.8,13.461-10.651,15.095,2.451-3.369,1.032-7.44-.975-11.181l10.307-14.335A68.443,68.443,0,0,0,396.876,196.432Z",
    transform: "translate(-281.54 -162.952)",
    opacity: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M387.46,212.289s2.867,2.595,6.121,5.1c3.928-2.609,13.045-9.447,11.941-14.608-.76-1.434-4.86-1.935-4.86-1.935S397.007,207,387.46,212.289Z",
    transform: "translate(-280.582 -156.519)",
    fill: "#14465e"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M389.682,211.362a27.8,27.8,0,0,0-4.7,6.408c-3.326-1.634-2.939-11.54-1.935-12.744a11.067,11.067,0,0,1,5.132-2.036A9.089,9.089,0,0,0,389.682,211.362Z",
    transform: "translate(-282.804 -155.591)",
    fill: "#14465e"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    transform: "translate(99.531 44.331)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M387.46,212.289s2.867,2.595,6.121,5.1c3.928-2.609,13.045-9.447,11.941-14.608-.76-1.434-4.86-1.935-4.86-1.935S397.007,207,387.46,212.289Z",
    transform: "translate(-380.113 -200.85)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M389.682,211.362a27.8,27.8,0,0,0-4.7,6.408c-3.326-1.634-2.939-11.54-1.935-12.744a11.067,11.067,0,0,1,5.132-2.036A9.089,9.089,0,0,0,389.682,211.362Z",
    transform: "translate(-382.335 -199.922)",
    fill: "#fff"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M394.485,333.254l5.734-31.394-1.1-16.6S391.26,314.059,394.485,333.254Z",
    transform: "translate(-277.873 -119.926)",
    opacity: 0.2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M374.31,179.5c-1.133,3.971-.229,12.042,5.2,9.261S376.259,172.666,374.31,179.5Z",
    transform: "translate(-286.469 -166.61)",
    fill: "#263238"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M402.658,185.984c.889,10.121,1.921,16-2.38,21.847-6.479,8.816-19.582,5.963-23.481-3.713-3.512-8.7-4.372-23.782,4.874-29.143a13.991,13.991,0,0,1,20.987,11.009Z",
    transform: "translate(-286.275 -168.56)",
    fill: "#e4897b"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M384.348,185.939c.115.8-.215,1.534-.745,1.606s-1.075-.53-1.2-1.348.215-1.534.76-1.606S384.219,185.179,384.348,185.939Z",
    transform: "translate(-282.788 -163.57)",
    fill: "#263238"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M377.882,186.839c.129.817-.215,1.534-.745,1.606s-1.075-.516-1.19-1.333.215-1.548.745-1.62S377.767,186.022,377.882,186.839Z",
    transform: "translate(-285.583 -163.18)",
    fill: "#263238"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M380.287,186.42a28.67,28.67,0,0,1-2.967,7.3,4.888,4.888,0,0,0,3.985.115Z",
    transform: "translate(-284.978 -162.775)",
    fill: "#de5753"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M386.76,183.863a.516.516,0,0,1-.487-.129,3.856,3.856,0,0,0-3.311-1.161.5.5,0,0,1-.588-.373.473.473,0,0,1,.373-.573,4.816,4.816,0,0,1,4.215,1.433.488.488,0,0,1,0,.688A.6.6,0,0,1,386.76,183.863Z",
    transform: "translate(-282.792 -164.877)",
    fill: "#263238"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M374.369,185.753a.487.487,0,0,1-.6-.616,4.774,4.774,0,0,1,3.053-3.182.487.487,0,0,1,.588.344.473.473,0,0,1-.33.6,3.684,3.684,0,0,0-2.38,2.537.516.516,0,0,1-.33.315Z",
    transform: "translate(-286.528 -164.717)",
    fill: "#263238"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M386.5,181.5s2.494-2.365,4.042-.4,2.265,7.669,2.265,7.669l.416-1.089s5.3,12.2,10.035,8.286,10.565-17.819-2.423-22.721c0,0-1.706-2.867-9.891-3.3s-17.2,5.834-18.091,11.339,1.792,8.114,1.792,8.114a7.6,7.6,0,0,1,1.1-3.326,3.326,3.326,0,0,0,2.322,2.15,5.734,5.734,0,0,1,.229-3.211,6.521,6.521,0,0,0,1.677,2.365c-.158-5.519,3.383-7.168,4.559-7.254A2.021,2.021,0,0,1,386.5,181.5Z",
    transform: "translate(-286.992 -169.925)",
    fill: "#263238"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M400.51,189.113a9.547,9.547,0,0,1-3.885,6.236c-2.767,1.935-5.3-.272-5.49-3.469-.172-2.867,1.061-7.368,4.3-8.028a4.387,4.387,0,0,1,5.075,5.261Z",
    transform: "translate(-278.996 -163.919)",
    fill: "#e4897b"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M380.64,195.41a26.781,26.781,0,0,1,2.781,2.552l.545-.373c2.48-1.72,3.068-3.326,2.967-4.6a3.77,3.77,0,0,0-.616-1.72,3.626,3.626,0,0,0-.674-.817,13.962,13.962,0,0,1-4.157,4.3A7.155,7.155,0,0,1,380.64,195.41Z",
    transform: "translate(-283.538 -161.028)",
    fill: "#263238"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M381.23,194.817l.831.731c2.337-1.62,3.756-3.068,4-4.3a3.631,3.631,0,0,0-.674-.817,13.962,13.962,0,0,1-4.157,4.387Z",
    transform: "translate(-283.283 -161.036)",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M383,196.822c2.48-1.72,3.068-3.326,2.967-4.6a10.036,10.036,0,0,0-2.38,2.451A3.714,3.714,0,0,0,383,196.822Z",
    transform: "translate(-282.516 -160.26)",
    fill: "#a24e3f"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M382.619,271.258l-.989-5.419,52.151-7.669.8,9.476Z",
    transform: "translate(-283.109 -131.67)",
    fill: "#263238"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M385.845,264.1l.459,3-4.172.5-.5-2.982Z",
    transform: "translate(-283.109 -129.099)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M413.088,261.56l.473,3.168-27.222,3.254-.459-3.025Z",
    transform: "translate(-281.267 -130.2)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M423.946,263.163l-17.288,2.064-.487-3.154,17.474-2.193Z",
    transform: "translate(-272.471 -130.929)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M392.318,264.453l.2,1.047a1.032,1.032,0,0,0,1.118.817l4.516-.545a1.018,1.018,0,0,0,.889-1.175l-.129-1.075a1.018,1.018,0,0,0-1.133-.889l-4.587.573a1.018,1.018,0,0,0-.874,1.247Z",
    transform: "translate(-278.488 -129.739)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_30",
    "data-name": "Line 30",
    y1: 0.172,
    x2: 1.419,
    transform: "translate(118.117 134.427)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M426.9,254.87l-12.9-.86,1.061,11.2s8.888,1.864,12.973-4.415Z",
    transform: "translate(-269.076 -133.473)",
    fill: "#e4897b"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M408.27,257.766l2.781,8.157,6.623-.717-1.046-11.2Z",
    transform: "translate(-271.56 -133.473)",
    fill: "#e4897b"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M413.485,229.488C410,224.3,409.07,215.64,409.07,215.64A7.612,7.612,0,0,1,412.6,217.4c.2,3.942.487,7.8.831,11.554C413.442,229.129,413.457,229.316,413.485,229.488Z",
    transform: "translate(-271.214 -150.107)",
    opacity: 0.2
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M418.189,204.9A208.7,208.7,0,0,1,432.6,220.511c2.308,2.724,4.544,5.533,6.666,8.6,1.061,1.505,2.122,3.053,3.125,4.745a31.21,31.21,0,0,1,2.867,6.021,14.777,14.777,0,0,1,.631,4.3,22.944,22.944,0,0,1-.258,3.412,44.525,44.525,0,0,1-1.319,5.82,86.931,86.931,0,0,1-3.842,10.307A146.22,146.22,0,0,1,430.431,282.5l-6.006-3c2.294-6.394,4.544-12.9,6.451-19.31a95.677,95.677,0,0,0,2.38-9.49,30.1,30.1,0,0,0,.573-4.372,14.347,14.347,0,0,0,0-1.778c0-.487-.158-.831-.186-.774a22.829,22.829,0,0,0-1.907-3.182c-.86-1.218-1.806-2.494-2.867-3.756-2.021-2.523-4.215-5.046-6.436-7.555s-4.559-4.96-6.881-7.44-4.7-4.931-6.981-7.34Z",
    transform: "translate(-271.43 -154.763)",
    fill: "#dc897c"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M411.828,202.437c13.733-2.122,29.043,24.37,29.043,24.37L426.636,236.97A156.254,156.254,0,0,1,407.427,221.2C399.242,212.83,402.7,203.856,411.828,202.437Z",
    transform: "translate(-273.928 -155.884)",
    fill: "#14465e"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M411.828,202.437c13.733-2.122,29.043,24.37,29.043,24.37L426.636,236.97A156.254,156.254,0,0,1,407.427,221.2C399.242,212.83,402.7,203.856,411.828,202.437Z",
    transform: "translate(-273.928 -155.884)",
    fill: "#fff",
    opacity: 0.7
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M324.01,419.386l1.061,2.8,1.09-2.781.143-14.536-2.15-.014Z",
    transform: "translate(-308.088 -68.082)",
    fill: "#263238"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M0,0H10.622V29.344a1.978,1.978,0,0,1-1.978,1.978H1.978A1.978,1.978,0,0,1,0,29.344Z",
    transform: "translate(25.242 45.501) rotate(-179.45)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M323.12,211.031l10.622.1.287-29.4a1.95,1.95,0,0,0-1.907-1.95h-6.78a1.907,1.907,0,0,0-1.935,1.892Z",
    transform: "translate(-308.474 -165.653)",
    fill: "#fff",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M324.536,196.58l14.464.143a4.989,4.989,0,0,1,4.931,4.86q3.569,137.532-2.867,275.106h0s-2.437,18.449-10.551,30.29h-3.569C319.046,495,316.91,476.5,316.91,476.5h0q-3.6-137.575,2.595-275.163a4.989,4.989,0,0,1,5.032-4.759Z",
    transform: "translate(-311.74 -158.37)",
    fill: "#263238"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M315.594,193.9l24.37.229a1.433,1.433,0,0,1,1.434,1.505v2.451l-24.8-.244c-2.093,36.927-.86,67.7-.86,67.7l1.806.889-1.964,7.168c-4.372-12.314-2.179-67.848-1.72-78.084a1.677,1.677,0,0,1,1.734-1.62Z",
    transform: "translate(-312.903 -159.532)",
    fill: "#263238"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 29.502,
    height: 5.662,
    transform: "translate(33.427 176.751) rotate(-179.45)",
    fill: "#263238"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M346.037,326.793q-.889,40.913-2.609,81.71a2.294,2.294,0,0,1-2.322,2.193L318,410.439a2.294,2.294,0,0,1-2.265-2.251q-.975-40.726-1.032-81.71a2.308,2.308,0,0,1,2.322-2.308l26.749.258a2.308,2.308,0,0,1,2.265,2.365Z",
    transform: "translate(-312.124 -103.058)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 29.502,
    height: 5.662,
    transform: "translate(33.427 176.751) rotate(-179.45)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M315.594,193.9l24.37.229a1.433,1.433,0,0,1,1.434,1.505v2.451l-24.8-.244c-2.093,36.927-.86,67.7-.86,67.7l1.806.889-1.964,7.168c-4.372-12.314-2.179-67.848-1.72-78.084a1.677,1.677,0,0,1,1.734-1.62Z",
    transform: "translate(-312.903 -159.532)",
    fill: "#fff",
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M346.037,326.793q-.889,40.913-2.609,81.71a2.294,2.294,0,0,1-2.322,2.193L318,410.439a2.294,2.294,0,0,1-2.265-2.251q-.975-40.726-1.032-81.71a2.308,2.308,0,0,1,2.322-2.308l26.749.258a2.308,2.308,0,0,1,2.265,2.365Z",
    transform: "translate(-312.124 -103.058)",
    fill: "#fff",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_94",
    "data-name": "Rectangle 94",
    width: 156.174,
    height: 26.174,
    transform: "translate(120.333 125.638)",
    fill: "#fff"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Dasthkat",
    transform: "matrix(0.999, -0.035, 0.035, 0.999, 405.273, 413.619)",
    fill: "#14465e",
    fontSize: 20,
    fontFamily: "Georgia-Bold, Georgia",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Dasthkat")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDasthkathSignHereVector);
export default __webpack_public_path__ + "static/media/dasthkath-sign-here-vector.f6e8daf972e66f4e1c481b302aa8c0c5.svg";
export { ForwardRef as ReactComponent };